import {useEffect, useState} from "react";

// Il + di develop (CardCrud e albero asset) era absolute, bottom 16, right 16 nella card.
// Il Fab è large, 56px, senza override di tema e senza breakpoint proprio.
// La card sta nel padding della pagina: px 3 (24) da lg e px 1 (8) sotto, pb 3px.
// La pagina riserva lo spazio della scrollbar su entrambi i lati (scrollbar-gutter: stable both-edges):
// a destra quello spazio si somma al padding, quindi va aggiunto all'ancora.
// Da lg la colonna ha pb 2 (16); sotto lg la pagina ha mb 1 (8).
const ADD_FAB_EDGE = 16;
const ADD_FAB_SIZE = 56;

const pageFabAnchor = (
  spacing: (factor: number) => string,
  isDownLg: boolean,
  panelWidth = 0,
  scrollbarGutter = 0,
) => ({
  bottom: parseFloat(spacing(isDownLg ? 1 : 2)) + 3 + ADD_FAB_EDGE,
  right:
    parseFloat(spacing(isDownLg ? 1 : 3)) +
    scrollbarGutter +
    ADD_FAB_EDGE +
    panelWidth,
});

// Spazio riservato dalla scrollbar verticale, misurato con il CSS globale della pagina
// (index.css la porta a 6px su WebKit; 0 con le scrollbar sovrapposte), invece di fissarlo.
const measureScrollbarGutter = (): number => {
  if (typeof document === "undefined" || !document.body) {
    return 0;
  }
  const probe = document.createElement("div");
  probe.style.position = "absolute";
  probe.style.top = "-9999px";
  probe.style.width = "100px";
  probe.style.height = "100px";
  probe.style.overflow = "scroll";
  probe.style.visibility = "hidden";
  document.body.appendChild(probe);
  const gutter = probe.offsetWidth - probe.clientWidth;
  document.body.removeChild(probe);
  return Math.max(0, gutter);
};

// Si rimisura al resize: lo zoom del browser cambia la larghezza della scrollbar in px CSS.
const useScrollbarGutter = () => {
  const [gutter, setGutter] = useState(0);
  useEffect(() => {
    const update = () => setGutter(measureScrollbarGutter());
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);
  return gutter;
};

export {
  ADD_FAB_SIZE,
  measureScrollbarGutter,
  pageFabAnchor,
  useScrollbarGutter,
};
